import { fetchClipSharesByBookmarkIdAction } from "@/api/actions/bookmarkClipShare";
import { ParamsBuilder, UrlParamsBuilderInput } from "@/api/paramsBuilders/paramsBuilder";

import { queryOptions } from "@tanstack/react-query";

export const bookmarkClipSharesOptions = (
  bookmarkId: number,
  queryBuilders?: UrlParamsBuilderInput
) => {
  return queryOptions({
    queryKey: ["clipShares", `bookmarkId-${bookmarkId}`, JSON.stringify(queryBuilders)] as const,
    queryFn: async () => {
      return await fetchClipSharesByBookmarkIdAction(bookmarkId, new ParamsBuilder(queryBuilders).build());
    },
  });
};